module.exports = __webpack_public_path__ + "img/cover-game-06.84ab27f2.jpg";